import { TextField } from "@mui/material"

const ReadOnlyTextField = (props) => (
  <TextField
    fullWidth
    variant="outlined"
    InputProps={{
      readOnly: true
    }}
    {...props}
  />
)

export default ReadOnlyTextField